let _handler = null;

export const registerAlertHandler = (fn) => { _handler = fn; };

export const showGlobalAlert = ({ type, title, message }) => {
    _handler?.({ type, title, message });
};
